export const environment = {
  production: true,
  baseUrl: 'https://backend-dev.splurky.com/api',
  imageUrl: 'https://backend-dev.splurky.com/api/media/video-preview-s3',
  productUrl: 'https://backend-dev.splurky.com',
  pluginUrl: 'https://backend-dev.splurky.com',
  socUrl: 'https://notification-dev.splurky.com/events/start?channel=',
  labelUrl: 'https://storage.googleapis.com/splurky-assets-dev/',
  cloudName: 'splurky',
  cloudFolder: 'splurky-dev',
  storeProfileUrl : 'https://dev.splurky.com/account/myprofile',
  streamUrl : 'https://dev.splurky.com/',
  videoBucketName: 'dev-blazing-card-agora-streams',
  baseBucketUrl: 's3.amazonaws.com',
  chatUrl: 'https://chat-dev.splurky.com',
  stripePublicKey: 'pk_test_51PkhgURoNstAiYcVPTVnYPKN4jVsuByZfM9IUf48hE8zqJKDfpRSkztFwvsb5SGyjh5KSJr6ihIlw8VEg03rjFBH00dBDCmHKo',
};